export const HOPES_GOALS_AMBITIONS_REQUEST = "HOPES_GOALS_AMBITIONS_REQUEST";
export const HOPES_GOALS_AMBITIONS_SUCCESS = "HOPES_GOALS_AMBITIONS_SUCCESS";
export const HOPES_GOALS_AMBITIONS_FAILURE = "HOPES_GOALS_AMBITIONS_FAILURE";

export const UPDATE_HOPES_GOALS_AMBITIONS_REQUEST =
  "UPDATE_HOPES_GOALS_AMBITIONS_REQUEST";
export const UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS =
  "UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS";
export const UPDATE_HOPES_GOALS_AMBITIONS_FAILURE =
  "UPDATE_HOPES_GOALS_AMBITIONS_FAILURE";

export const ADD_PERSONAL_SMART_GOALS_REQUEST =
  "ADD_PERSONAL_SMART_GOALS_REQUEST";
export const ADD_PERSONAL_SMART_GOALS_SUCCESS =
  "ADD_PERSONAL_SMART_GOALS_SUCCESS";
export const ADD_PERSONAL_SMART_GOALS_FAILURE =
  "ADD_PERSONAL_SMART_GOALS_FAILURE";

export const ADD_EDIT_GOALS_ASSESSMENT_REQUEST =
  "ADD_EDIT_GOALS_ASSESSMENT_REQUEST";
export const ADD_EDIT_GOALS_ASSESSMENT_SUCCESS =
  "ADD_EDIT_GOALS_ASSESSMENT_SUCCESS";
export const ADD_EDIT_GOALS_ASSESSMENT_FAILURE =
  "ADD_EDIT_GOALS_ASSESSMENT_FAILURE";

export const DELETE_PERSONAL_SMART_GOALS_REQUEST =
  "DELETE_PERSONAL_SMART_GOALS_REQUEST";
export const DELETE_PERSONAL_SMART_GOALS_SUCCESS =
  "DELETE_PERSONAL_SMART_GOALS_SUCCESS";
export const DELETE_PERSONAL_SMART_GOALS_FAILURE =
  "DELETE_PERSONAL_SMART_GOALS_FAILURE";

export const GET_PERSONAL_SMART_GOALS_REQUEST =
  "GET_PERSONAL_SMART_GOALS_REQUEST";
export const GET_PERSONAL_SMART_GOALS_SUCCESS =
  "GET_PERSONAL_SMART_GOALS_SUCCESS";
export const GET_PERSONAL_SMART_GOALS_FAILURE =
  "GET_PERSONAL_SMART_GOALS_FAILURE";

export const GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST =
  "GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST";
export const GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS =
  "GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS";
export const GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE =
  "GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE";

export const GET_CURRENT_SLP_GOALS_PDF_REQUEST =
  "GET_CURRENT_SLP_GOALS_PDF_REQUEST";
export const GET_CURRENT_SLP_GOALS_PDF_SUCCESS =
  "GET_CURRENT_SLP_GOALS_PDF_SUCCESS";
export const GET_CURRENT_SLP_GOALS_PDF_FAILURE =
  "GET_CURRENT_SLP_GOALS_PDF_FAILURE";

export const ADD_WHERE_TO_FROM_HERE_REQUEST = "ADD_WHERE_TO_FROM_HERE_REQUEST";
export const ADD_WHERE_TO_FROM_HERE_SUCCESS = "ADD_WHERE_TO_FROM_HERE_SUCCESS";
export const ADD_WHERE_TO_FROM_HERE_FAILURE = "ADD_WHERE_TO_FROM_HERE_FAILURE";
